import _ from 'lodash';
import { useContext, useEffect, useState } from 'react';
import { Collapse, ListGroup } from 'react-bootstrap';
import { DepartmentMenuContext } from '..';
import { SquareMinusIcon, SquarePlusIcon } from '../icons';
import { CompanyNode } from '../models/company';
import { DepartmentNode } from '../models/department';
import { getDepartmentKey, isCompanyNode } from '../utils';

export interface DepartmentMenuItemProps {
  data: DepartmentNode | CompanyNode;
}

export function DepartmentMenuItem({ data }: DepartmentMenuItemProps) {
  const branchKey = getDepartmentKey(data);

  const departmentMenuContext = useContext(DepartmentMenuContext);
  const isExpandable = data.departments && data.departments.length > 0;

  //state
  const [open, setOpen] = useState(true);
  const [isSelected, setIsSelected] = useState(
    departmentMenuContext.path.some((pathItem) => pathItem.id === branchKey.id && pathItem.cd === branchKey.cd)
  );

  const selectedBranchKey =
    departmentMenuContext.path.length > 0
      ? departmentMenuContext.path[departmentMenuContext.path.length - 1]
      : undefined;

  function handleMenuClick(e: React.MouseEvent<HTMLButtonElement>) {
    if (departmentMenuContext.allowSelectTypes?.includes(data.classification)) {
      departmentMenuContext.changeSelectedDepartment && departmentMenuContext.changeSelectedDepartment(data);
    }
  }

  function handleToggleCollapse() {
    setOpen(!open);
  }

  useEffect(() => {
    setIsSelected(
      departmentMenuContext.path.some((pathItem) => pathItem.id === branchKey.id && pathItem.cd === branchKey.cd)
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [departmentMenuContext]);

  const MenuItemRoot = (
    <ListGroup.Item
      id={`branch-${branchKey.id}-${branchKey.cd}`}
      className={`${isExpandable ? 'dt-parent' : ''} ${isSelected ? 'isSelected' : ''} ${open ? 'isOpen' : ''} ${
        _.isEqual(selectedBranchKey, branchKey) ? 'menu-selected' : ''
      }`}
    >
      {isExpandable && (
        <div className="branch-icon" onClick={handleToggleCollapse}>
          {open ? (
            <SquareMinusIcon
              width={14}
              height={16}
              color={isSelected && _.isEqual(selectedBranchKey, branchKey) ? 'white' : 'black'}
            />
          ) : (
            <SquarePlusIcon
              width={14}
              height={16}
              color={isSelected && _.isEqual(selectedBranchKey, branchKey) ? 'white' : 'black'}
            />
          )}
        </div>
      )}
      <button className="branch-name d-flex align-items-center w-100" onClick={handleMenuClick}>
        <span className="branch-link">{isCompanyNode(data) ? data.company_name : data.department_name}</span>
      </button>
    </ListGroup.Item>
  );

  const MenuItemChildren = isExpandable ? (
    <Collapse in={open}>
      <ListGroup>
        {data.departments?.map((item) => (
          <DepartmentMenuItem key={isCompanyNode(item) ? item.company_cd : item.department_cd} data={item} />
        ))}
      </ListGroup>
    </Collapse>
  ) : null;

  if ((data.departments === undefined || data.departments.length === 0) && data.classification !== 'T') {
    return null;
  }

  return (
    <>
      {MenuItemRoot}
      {MenuItemChildren}
    </>
  );
}
